export default __webpack_public_path__ + "static/media/Audio_Default_Icon.9500b712.svg";